import React from "react";
import { ChevronDown, ChevronUp, Search, X } from "lucide-react";

interface Props {
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  matchCount: number;
  currentMatch: number;
  goNext: () => void;
  goPrev: () => void;
  clearSearch: () => void;
}

export default function SearchBar({
  searchQuery, setSearchQuery,
  matchCount, currentMatch,
  goNext, goPrev, clearSearch,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* Input */}
      <div className="relative flex items-center">
        <Search size={14} className="pointer-events-none absolute left-2.5 text-slate-400" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.shiftKey ? goPrev() : goNext();
            if (e.key === "Escape") clearSearch();
          }}
          placeholder="Search in content..."
          className="h-8 w-52 rounded-lg border border-slate-700 bg-slate-950 pl-8 pr-7 text-xs text-slate-200 placeholder-slate-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500/40"
        />
        {searchQuery && (
          <button type="button" onClick={clearSearch} className="absolute right-2 text-slate-500 hover:text-slate-300">
            <X size={12} />
          </button>
        )}
      </div>

      {/* Counter */}
      {searchQuery && (
        <span className={`min-w-[70px] text-center text-xs font-semibold ${matchCount === 0 ? "text-rose-400" : "text-emerald-400"}`}>
          {matchCount === 0 ? "No matches" : `${currentMatch} / ${matchCount}`}
        </span>
      )}

      {/* Prev / Next */}
      {matchCount > 0 && (
        <div className="flex items-center gap-1">
          <button type="button" onClick={goPrev} title="Previous (Shift+Enter)"
            className="flex h-7 w-7 items-center justify-center rounded-md border border-slate-700 text-slate-400 hover:bg-slate-800 hover:text-white">
            <ChevronUp size={14} />
          </button>
          <button type="button" onClick={goNext} title="Next (Enter)"
            className="flex h-7 w-7 items-center justify-center rounded-md border border-slate-700 text-slate-400 hover:bg-slate-800 hover:text-white">
            <ChevronDown size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
